'use client';

import { BookDemoButton } from '@/components/ui';
import IndustryHero from '@/components/industry/IndustryHero';
import IndustryCommandCentre from '@/components/industry/IndustryCommandCentre';
import { useTranslation } from '@/hooks/useTranslation';

const BLUE = { color: 'var(--brand)' };
const DEEP = { color: 'var(--brand-deep)' };

/* Sector command-centre data — Travel & hospitality guest operations.
   Sample/mock dashboard content (not marketing copy). */
const CC = {
  pulseTitle: 'Guest & booking pulse',
  kpis: [
    { val: '1,480', lbl: 'Live mentions', live: true },
    { val: '96', lbl: 'Open escalations' },
    { val: '3.3m', lbl: 'Avg. first response' },
  ],
  sentiment: [
    { lbl: 'Positive', pct: 39, tone: 'positive' },
    { lbl: 'Neutral', pct: 33, tone: 'neutral' },
    { lbl: 'Negative', pct: 28, tone: 'negative' },
  ],
  sla: { pct: 78, lbl: 'SLA met' },
  tickerLabel: 'Incoming complaints',
  tickerItems: [
    { letter: 'A', text: 'Booking cancelled, no refund', handle: '@aditya_r', tag: 'Refund', tagLevel: 'high' },
    { letter: 'M', text: 'Room not as advertised', handle: '@megha_s', tag: 'Stay', tagLevel: 'med' },
    { letter: 'S', text: 'Flight delayed, no assistance', handle: '@sameer_k', tag: 'Service', tagLevel: 'med' },
    { letter: 'P', text: 'Worst experience, never again', handle: '@pooja_d', tag: 'Reputation', tagLevel: 'high' },
  ],
  chips: [
    { variant: 'light', title: 'Guest risk', sub: 'Negative reviews trending up' },
    { variant: 'dark', title: 'AgentIQ routed', sub: 'Refund case → desk in 2s' },
  ],
};

export default function TravelHero() {
  const { t } = useTranslation();

  return (
    <IndustryHero
      layout="visual"
      breadcrumb={{
        ariaLabel: t('breadcrumb.breadcrumb'),
        label: t('footer.col.industries'),
        href: '/industries',
        current: t('Travel & Hospitality'),
      }}
      title={
        <>
          {t('industries_travel_and_hospitality.guest_experience_lives_online_now_t')}{' '}
          <span className="serif-accent italic">{t('industries_travel_and_hospitality.travel_hospitality_customer_experie')}</span>
          {' '}{t('industries_travel_and_hospitality.for')}{' '}
          <span className="serif-accent italic">{t('industries_travel_and_hospitality.hotels_airlines_otas_worldwide')}</span>.
        </>
      }
      lead={
        <>
          {t('industries_travel_and_hospitality.a_single_viral')}{' '}
          <span style={BLUE}>{t('industries_travel_and_hospitality.guest_complaint')}</span> {t('industries_travel_and_hospitality.can_empty_a_hotels_bookings_for_a_w')}{' '}
          <span style={DEEP}>{t('industries_travel_and_hospitality.locobuzz_closes_that_gap')}</span>
        </>
      }
      actions={<BookDemoButton label={t('industries_travel_and_hospitality.hero_cta_primary')} />}
      visual={<IndustryCommandCentre ariaLabel="Travel & hospitality guest command centre" {...CC} />}
    />
  );
}
